<template>
    <div class="log-pane">
        <el-tabs v-model="actTab">
            <el-tab-pane label="跟进日报" name="stepLog">
                <div class="log-header">
                    <el-row>
                        <el-col :span="2" :offset="1"><span class="label">操作人</span></el-col>
                        <el-col :span="4"><span class="label">操作时间</span></el-col>
                        <el-col :span="5"><span class="label">操作动作</span></el-col>
                        <el-col :span="12"><span class="label">备注</span></el-col>
                    </el-row>
                </div>

                <el-timeline class="log-timeline">
                    <el-timeline-item
                        v-for="log in computedStepLog || []"
                        :key="log.id"
                        :timestamp="log.create_at"
                        color="#D5ECFF"
                        placement="center"
                    >
                        <el-row class="log-box">
                            <el-col :offset="1" :span="2" class="log-i">{{ log.operator }}</el-col>
                            <el-col :span="4" class="log-i">
                                <el-tooltip class="item" effect="light" placement="top" :content="log.create_at">
                                    <span>{{ displayLogStepDate(log.create_at) }}</span>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="5" class="log-i">{{
                                displayLogStepText(log.step_id, log.new_step_id)
                            }}</el-col>
                            <el-col :span="12" class="log-i">{{ log.comment }}</el-col>
                        </el-row>
                    </el-timeline-item>
                </el-timeline>
                <div v-if="stepLog && stepLog.length > 4" class="toggle-expand-btn" @click="toggleStep">
                    <span class="text">{{ this.stepExpand ? '收起' : '查看更多' }}</span>
                    <span :class="this.stepExpand ? 'up' : 'down'"></span>
                </div>
            </el-tab-pane>

            <el-tab-pane label="流转日志" name="transLog">
                <div class="log-header">
                    <el-row>
                        <el-col :span="2" :offset="1"><span class="label">操作人</span></el-col>
                        <el-col :span="4"><span class="label">操作时间</span></el-col>
                        <el-col :span="5"><span class="label">操作动作</span></el-col>
                        <el-col :span="12"><span class="label">备注</span></el-col>
                    </el-row>
                </div>

                <el-timeline class="log-timeline">
                    <el-timeline-item
                        v-for="log in computedTransLog || []"
                        :key="log.id"
                        :timestamp="log.create_at"
                        color="#D5ECFF"
                        placement="center"
                    >
                        <el-row class="log-box">
                            <el-col :offset="1" :span="2" class="log-i">{{ log.operator }}</el-col>
                            <el-col :span="4" class="log-i">
                                <el-tooltip class="item" effect="light" placement="top" :content="log.create_at">
                                    <span>{{ displayLogStepDate(log.create_at) }}</span>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="5" class="log-i">{{ log.content || '' }}</el-col>
                            <el-col :span="12" class="log-i">{{ log.ext || '--' }}</el-col>
                        </el-row>
                    </el-timeline-item>
                </el-timeline>
                <div v-if="transLog && transLog.length > 4" class="toggle-expand-btn" @click="toggleTrans">
                    <span class="text">{{ this.transExpand ? '收起' : '查看更多' }}</span>
                    <span :class="this.transExpand ? 'up' : 'down'"></span>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
// import $conf from '@/common/conf';

export default {
    name: 'DetailLogPane',
    computed: {
        computedStepLog () {
            let ret = [];
            if (this.stepExpand) {
                ret = this.stepLog;
            } else {
                ret = this.stepLog.slice(0, 4);
            }
            return ret;
        },

        computedTransLog () {
            let ret = [];
            if (this.transExpand) {
                ret = this.transLog;
            } else {
                ret = this.transLog.slice(0, 4);
            }
            return ret;
        }
    },
    props: {
        stepLog: {
            type: Array,
            required: true,
            default: () => []
        },
        transLog: {
            type: Array,
            required: true,
            default: () => []
        },
        steps: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data: () => ({
        actTab: 'stepLog',
        stepExpand: false,
        transExpand: false
    }),
    methods: {
        // 匹配进度id
        matchStepId (id) {
            return (this.steps.find(i => i.id * 1 === id * 1) || {}).name || '';
        },

        // 显示log 日期
        displayLogStepDate (date = '') {
            return date.split(' ')[0] || '';
        },

        // 显示log 进度文字
        displayLogStepText (cur = '', next = '') {
            if (cur === next) {
                return this.matchStepId(next);
            } else {
                return `${this.matchStepId(cur)} ---> ${this.matchStepId(next)}`;
            }
        },

        toggleStep () {
            this.stepExpand = !this.stepExpand;
        },

        toggleTrans () {
            this.transExpand = !this.transExpand;
        }
    }
};
</script>

<style lang="less" scoped>
.log-pane {
    /deep/ .el-tabs__item {
        font-size: 16px;
        margin-bottom: 8px;
    }
    /deep/ .log-box {
        border-bottom: none !important;
    }
    .log-header {
        margin-bottom: 24px;
        padding-left: 28px;
        padding-bottom: 16px;
        border-bottom: 1px solid #ddd;

        .label {
            font-size: 14px;
            font-weight: bold;
            color: #373c40;
        }
    }

    .log-timeline {
        margin-left: -40px;
    }

    /deep/ .el-timeline-item__tail {
        border-left-color: #d5ecff;
    }

    /deep/ .el-timeline-item__node:before {
        content: '';
        position: absolute;
        top: 25%;
        left: 25%;
        width: 50%;
        height: 50%;
        border-radius: 50%;
        background: #2f9eff;
        z-index: 2;
    }

    .log-box {
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        color: #606266;
    }
    .toggle-expand-btn {
        margin: 0 auto;
        text-align: center;
        color: #2f9eff;
        font-size: 14px;
        cursor: pointer;
        .text {
            vertical-align: middle;
        }
        .up {
            vertical-align: middle;
            margin-left: 5px;
            margin-right: 6px;
            position: relative;
            &::after {
                position: absolute;
                top: 50%;
                transform: translate(0, -33%);
                content: ' ';
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-bottom: 5px solid #2f9eff;
            }
        }
        .down {
            vertical-align: middle;
            margin-left: 5px;
            margin-right: 6px;
            position: relative;
            &::after {
                position: absolute;
                top: 50%;
                transform: translate(0, -33%);
                content: ' ';
                width: 0;
                height: 0;
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 5px solid #2f9eff;
            }
        }
    }
}
</style>
